// ./helpers/DeviceConfigFormHelper.js

/**
 * Renders all available tabs, displaying only the active one.
 * Hides the 'server' tab if the user is not an admin.
 */
export function renderAllTabs(tabsContent, activeTabKey, admin) {
    return (
        <div style={{ width: '100%', overflow: 'hidden' }}>
            {Object.entries(tabsContent).map(([key, content]) => {
                if (key === 'server' && !admin) return null;

                const isActive = activeTabKey === key;

                return (
                    <div
                        key={key}
                        style={{
                            width: '100%',
                            opacity: isActive ? 1 : 0,
                            transform: isActive ? 'translateX(0)' : 'translateX(10px)',
                            transition: 'opacity 0.25s ease-in, transform 0.25s ease-in',
                            pointerEvents: isActive ? 'auto' : 'none',
                            height: isActive ? 'auto' : 0,
                            overflow: 'hidden',
                        }}
                    >
                        {content}
                    </div>
                );
            })}
        </div>
    );
}

/**
* Returns the list of visible tabs based on the device type.
*/
export function getTabListByType(currentType, admin, currentMode) {
    const base = [{ key: 'event', tab: 'Event Configuration' }];

    if (currentType === 'mobile') {
        const mode = String(currentMode || '').toLowerCase().trim();

        base.push({
            key: 'entranceControl',
            tab:
                mode === 'cloakroom'
                    ? 'Cloakroom'
                    : mode === 'nfclink'
                        ? 'NFC Link'
                        : 'Entrance Control Settings',
        });

        // Custom fields ONLY for cloakroom and normal entranceControl
        if (mode !== 'nfclink') {
            base.push({ key: 'customfields', tab: 'Custom Fields' });
        }
    } else if (currentType === 'desktop') {
        base.push({ key: 'selfcheckin', tab: 'Selfcheckin' });
        base.push({ key: 'images', tab: 'Images' });
        base.push({ key: 'texts', tab: 'Texts' });
        base.push({ key: 'animations', tab: 'Animations' });
        base.push({ key: 'participantTypes', tab: 'Participant Types' });
    } else if (currentType === 'leadcapture') {
        base.push({ key: 'leadcapture', tab: 'Lead Capture' });
    }

    if (admin) {
        base.push({ key: 'server', tab: 'Server' });
    }

    return base;
}

/**
* Returns the list of invalid (unallowed) tabs based on the device type.
*/
export function getInvalidTabsByType(type) {
    const map = {
        mobile: ['images', 'participantTypes', 'selfcheckin'],
        desktop: ['entranceControl', 'customfields'],
        leadcapture: ['images', 'texts', 'participantTypes', 'selfcheckin', 'entranceControl']
    };

    return map[type] || [];
}
